module.exports = __webpack_public_path__ + "static/media/the-departed 1000*1500.a419b51b.jpg";